export const securityContent = `# Security Notes

* Never expose your **secret key** in the browser.
* Keep Supabase **service role** server-side; the browser should use the **anon** key.
* If you perform server-side entitlement checks, call Lightswitch with your **secret key** only from your server.`;
